/** Existing client password rules shared by invitation and required-change forms. */
export function passwordRequirementChecks(value: string) {
  return [value.length >= 8, /[A-Z]/.test(value), /[a-z]/.test(value), /\d/.test(value)];
}
